import {create} from 'zustand';

type ReportState = {
  hasInlineComments: boolean;
  setHasInlineComments: (hasComments: boolean) => void;
};

export const useReportState = create<ReportState>()(set => ({
  hasInlineComments: false,
  setHasInlineComments: (hasComments: boolean) =>
    set(() => ({hasInlineComments: hasComments})),
}));
